import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import type { ThemeDefinition } from 'vuetify'

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    // Default colors
    anchor: '#000000',
    primary: '#2f5975',
    secondary: '#b9d0df',
    tertiary: '#d3e1eb',
    highlight: '#f7a35a',
    action: '#ff7e6d',
    soft: '#d2e3c8',
    accent: '#384437',
    lightBlue: '#90caf9',

    // Container colors
    background: '#eceff1',
    surface: '#ffffff',

    // State colors
    error: '#ba1a1a',
    running: '#199f19',
    failure: '#B00020',
    cancel: '#ba1a1a',
    run: '#199f19',
    unspecified: '#777777',
    pending: '#2196f3',
    new: '#2196f3',
    completed: '#199f19',

    // Surface Container
    surfaceContainerHighest: '#e6e8eb',
    surfaceContainerHigh: '#eeeef1',
    surfaceContainer: '#ECF2F6',
    surfaceContainerLow: '#f7f9fc',
    surfaceContainerLowest: '#FFFFFF',

    // On colors
    onPrimary: '#FFFFFF',
    'onPrimary--high': '#E0E0E0',
    'onPrimary--medium': '#A0A0A0',
    'onPrimary--disabled': '#6C6C6C',
    onBackground: '#777777',
    'onSurface--high': '#000000',
    'onSurface--medium': '#000000',
    'onSurface--disabled': '#000000',
    onError: '#FFFFFF',
  },
}

const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'lightTheme',
    themes: {
      lightTheme,
    },
  },
})

export default vuetify
